import { Container } from 'inversify';
import GatewayNames from 'constant/GatewayNames';
import HttpClient from 'gateway/HttpClient';
import ApiClient from '../gateway/ApiClient';
import { UserClient } from '../client/user/UserClient';
import TransactionClient from 'client/transaction/TransactionClient';
import NestFolderClient from 'client/folder/NestFolderClient';
import NestTransactionClient from '../client/transaction/NestTransactionClient';
import NestRuleClient from '../client/rule/NestRuleClient';
import FolderClient from '../client/folder/FolderClient';
import RuleClient from '../client/rule/RuleClient';
import NestUserClient from '../client/user/NestUserClient';
import { RoleClient } from '../client/role/RoleClient';
import NestRoleClient from '../client/role/NestRoleClient';
import { GroupClient } from '../client/group/GroupClient';
import NestGroupClient from '../client/group/NestGroupClient';
import { AuditClient } from '../client/audit/AuditClient';
import NestAuditClient from '../client/audit/NestAuditClient';
import ListClient from '../client/list/ListClient';
import NestListClient from '../client/list/NestListClient';
import ListDataClient from '../client/list/ListDataClient';
import NestListDataClient from '../client/list/NestListDataClient';
import CaseClient from '../client/integration/case/CaseClient';
import NestCaseClient from '../client/integration/case/NestCaseClient';
import ConnectionClient from '../client/connection/ConnectionClient';
import NestConnectionClient from '../client/connection/NestConnectionClient';
import CaseSettingsClient from '../client/integration/configuration/CaseSettingsClient';
import NestCaseSettingsClient from '../client/integration/configuration/NestCaseSettingsClient';
import NestStructClient from '../client/struct/NestStructClient';
import StructClient from '../client/struct/StructClient';
import EnrichmentClient from '../client/enrichment/EnrichmentClient';
import NestEnrichmentClient from '../client/enrichment/NestEnrichmentClient';
import SandboxClient from '../client/sandbox/SandboxClient';
import NestSandboxClient from '../client/sandbox/NestSandboxClient';
import { StreamClient } from '../client/stream/StreamClient';
import NestStreamClient from '../client/stream/NestStreamClient';
import ActionClient from '../client/action/ActionClient';
import NestActionClient from '../client/action/NestActionClient';
import JobClient from '../client/job/JobClient';
import NestJobClient from '../client/job/NestJobClient';
import MakerCheckerClient from '../client/maker-checker/MakerCheckerClient';
import NestMakerCheckerClient from '../client/maker-checker/NestMakerCheckerClient';
import NotificationClient from '../client/notification/NotificationClient';
import NestNotificationClient from '../client/notification/NestNotificationClient';
import WatchlistClient from '../client/watchlist/WatchlistClient';
import NestWatchlistClient from '../client/watchlist/NestWatchlistClient';
import CustomListClient from '../client/custom-list/CustomListClient';
import NestCustomListClient from '../client/custom-list/NestCustomListClient';
import ChartClient from '../client/chart/ChartClient';
import NestChartClient from '../client/chart/NestChartClient';
import NestDashboardClient from '../client/dashboard/NestDashboardClient';
import DashboardClient from '../client/dashboard/DashboardClient';
import AiModelClient from '../client/ai/AiModelClient';
import NestAiModelClient from '../client/ai/NestAiModelClient';
import TrackerClient from '../client/tracker/TrackerClient';
import NestTrackerClient from '../client/tracker/NestTrackerClient';
import EntityClient from '../client/integration/entity/EntityClient';
import NestEntityClient from '../client/integration/entity/NestEntityClient';
import {CraClient} from "../client/cra/CraClient";
import NestCraClient from "../client/cra/NestCraClient";
import AchClient from '../client/ach/AchClient';
import NestAchClient from '../client/integration/ach/NestAchClient';

class GatewayContainer extends Container {
  private static instance: Container | null = null;

  private constructor(tenant: string) {
    super({ autoBindInjectable: true, defaultScope: 'Singleton' });
    this.bind<HttpClient>(GatewayNames.API_CLIENT).toConstantValue(new ApiClient(tenant));
    this.bind<TransactionClient>(GatewayNames.TRANSACTION_CLIENT).toConstantValue(new NestTransactionClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<FolderClient>(GatewayNames.FOLDER_CLIENT).toConstantValue(new NestFolderClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<RuleClient>(GatewayNames.RULE_CLIENT).toConstantValue(new NestRuleClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<UserClient>(GatewayNames.USER_CLIENT).toConstantValue(new NestUserClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<RoleClient>(GatewayNames.ROLE_CLIENT).toConstantValue(new NestRoleClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<GroupClient>(GatewayNames.GROUP_CLIENT).toConstantValue(new NestGroupClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<AuditClient>(GatewayNames.AUDIT_CLIENT).toConstantValue(new NestAuditClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<ListClient>(GatewayNames.LIST_CLIENT).toConstantValue(new NestListClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<ListDataClient>(GatewayNames.LIST_DATA_CLIENT).toConstantValue(new NestListDataClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<EnrichmentClient>(GatewayNames.ENRICHMENT_CLIENT).toConstantValue(new NestEnrichmentClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<CaseClient>(GatewayNames.CASE_CLIENT).toConstantValue(new NestCaseClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<EntityClient>(GatewayNames.ENTITY_CLIENT).toConstantValue(new NestEntityClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<CaseSettingsClient>(GatewayNames.DOMAIN_CONFIGURATION_CLIENT).toConstantValue(new NestCaseSettingsClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<ConnectionClient>(GatewayNames.CONNECTION_CLIENT).toConstantValue(new NestConnectionClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<StructClient>(GatewayNames.STRUCT_CLIENT).toConstantValue(new NestStructClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<SandboxClient>(GatewayNames.SANDBOX_CLIENT).toConstantValue(new NestSandboxClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<StreamClient>(GatewayNames.STREAM_CLIENT).toConstantValue(new NestStreamClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<ActionClient>(GatewayNames.ACTION_CLIENT).toConstantValue(new NestActionClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<WatchlistClient>(GatewayNames.WATCHLIST_CLIENT).toConstantValue(new NestWatchlistClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<CustomListClient>(GatewayNames.CUSTOM_LIST_CLIENT).toConstantValue(new NestCustomListClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<JobClient>(GatewayNames.JOB_CLIENT).toConstantValue(new NestJobClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<ChartClient>(GatewayNames.CHART_CLIENT).toConstantValue(new NestChartClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<DashboardClient>(GatewayNames.DASHBOARD_CLIENT).toConstantValue(new NestDashboardClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<MakerCheckerClient>(GatewayNames.MAKER_CHECKER_CLIENT).toConstantValue(new NestMakerCheckerClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<NotificationClient>(GatewayNames.NOTIFICATION_CLIENT).toConstantValue(new NestNotificationClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<AiModelClient>(GatewayNames.AI_CLIENT).toConstantValue(new NestAiModelClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<TrackerClient>(GatewayNames.TRACKER_CLIENT).toConstantValue(new NestTrackerClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<CraClient>(GatewayNames.CRA_CLIENT).toConstantValue(new NestCraClient(this.get(GatewayNames.API_CLIENT)));
    this.bind<AchClient>(GatewayNames.ACH_CLIENT).toConstantValue(new NestAchClient(this.get(GatewayNames.API_CLIENT)));
  }

  public static initialize(tenant: string) {
    GatewayContainer.getInstance(tenant);
  }

  public static clear() {
    GatewayContainer.instance = null;
  }

  public static getInstance(tenant?: string): Container {
    if (GatewayContainer.instance == null) {
      GatewayContainer.instance = new GatewayContainer(tenant!);
      return GatewayContainer.instance;
    } else {
      return GatewayContainer.instance!;
    }
  }
}

export default GatewayContainer;
